subscription NewMigrationLogsSubscription($migrationId: ID!) {
  newMigrationLogs(migrationId: $migrationId) {
    id
    migrationId
    message
    createdAt
  }
}
